export enum ConditionMode {
    Amount = 'amount',
    Percentage = 'percentage',
}
